<template lang="pug">
.wrapper
    .container.m-auto
        HeaderGlobal(HeaderGlobalHeading="Users" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading {{ page_title }}
                    .header-cta
                        router-link.btn-default(to="/users") 
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                            span.ml-2 Back
            //- .box__body
            .box__body
                .container-form(action="" method="method")
                    section.group-fields.border-b
                        .field.field--radio(v-if="auth_data.role && auth_data.role.label && auth_data.role.label === 'superadmin'")
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="type_form") Type
                            .field__form
                                .wrapper-radio.mr-6
                                    input(type="radio" name="type_form" value="" v-model="type_form")
                                    .ui-radio.flex.items-center
                                        .radio.flex.items-center.justify-center
                                        strong General
                                .wrapper-radio
                                    input(type="radio" name="type_form" value="bot" v-model="type_form")
                                    .ui-radio.flex.items-center
                                        .radio.flex.items-center.justify-center
                                        strong Bot

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="name") Name *
                            .field__form
                                input.field-style(id="name" name="name" type="text" v-model="name" maxlength="255")
                                .error(v-if="error_name !== null") {{ error_name }}

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="email") Email *
                            .field__form
                                input.field-style(id="email" name="email" type="email" v-model="email" maxlength="255")
                                .error(v-if="error_email !== null") {{ error_email }}

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="username") Username
                            .field__form
                                input.field-style(id="username" name="username" type="text" v-model="username" maxlength="255")
                                .error(v-if="error_username !== null") {{ error_username }}

                        .field(v-if="type_form=='bot'")
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="username_bot") Username Bot
                            .field__form
                                input.field-style(id="username_bot" name="username_bot" type="text" v-model="username_bot" maxlength="255")
                                .error(v-if="error_username_bot !== null") {{ error_username_bot }}

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="phone") Phone
                            .field__form
                                input.field-style(id="phone" name="phone" type="number" v-model="phone" maxlength="255")
                                .error(v-if="error_phone !== null") {{ error_phone }}

                        .field(v-if="isAstro !== 'true' && auth_data.role && auth_data.role.label === 'superadmin'")
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="client_id") Client *
                            .field__form
                                .relative
                                    select.field-style(name="client_id" v-model="client_id" @change="setEmptyRoleId()")
                                        option(value="") - Select Client -
                                        template(v-if="clients_list.data && clients_list.data.length > 0")
                                            option(v-for="(client,index) in clients_list.data" :key="client.id" :value="client.id") {{ client.name }}
                                    .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                .error(v-if="error_client_id !== null") {{ error_client_id }}

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="role_id") Role *
                            .field__form
                                .relative
                                    select.field-style(name="role_id" v-model="role_id")
                                        option(value="") - Select Role -
                                        template(v-if="roles_list.data && roles_list.data.length > 0")
                                            option(v-for="(role,index) in roles_list.data" :key="role.id" :value="role.id") {{ role.name }}
                                    .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                .error(v-if="error_role_id !== null") {{ error_role_id }}

                        .field.field--radio
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="status") Status *
                            .field__form
                                .wrapper-radio.mr-6
                                    input(type="radio" name="status" value="1" v-model="status")
                                    .ui-radio.flex.items-center
                                        .radio.flex.items-center.justify-center
                                        strong Active
                                .wrapper-radio
                                    input(type="radio" name="status" value="0" v-model="status")
                                    .ui-radio.flex.items-center
                                        .radio.flex.items-center.justify-center
                                        strong Inactive
                                .error(v-if="error_status !== null") {{ error_status }}

                        // .field
                        .field(v-if="type_form=='bot'")
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="bot_menu") Bot Menu
                            .field__form
                                .table-static.w-full.p-4
                                    table.table-general
                                        // thead
                                            tr
                                                th(v-for="(th,index) in tableTheadBotMenu" :key="index" :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')") {{ th.name }}
                                        tbody
                                            tr(v-if="load_data_status_bot_menu_list === 'loading'")
                                                td.text-center(:colspan="tableTheadBotMenu.length")

                                            template(v-else-if="bot_menu_list.data && bot_menu_list.data.length > 0")
                                                tr(v-for="(botMenu,index) in bot_menu_list.data")
                                                    td {{ botMenu.label }}
                                                    td.text-center
                                                        .wrapper-checkbox
                                                            input(type="checkbox" :class="botMenu.label" :value="botMenu.index" v-model="bot_menu")
                                                            .ui-checkbox.flex.items-center
                                                                .checkbox.flex.items-center.justify-center
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>

                                            tr(v-else)
                                                //- td.text-center(:colspan="tableThead.length") No Data Available
                                                td.text-center No Data Available

                    section.group-fields.border-b

                        //- .field.mb-4
                            label.block.text-sm.font-bold.mb-2(for="password") Old Password
                            input.field-style(id="old_password" name="old_password" type="password")
                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="password") Password {{ route_name === 'PageUsersCreate' ? '*' : ''}}
                            .field__form
                                input.field-style(id="password" name="password" type="password" v-model="password" maxlength="255")
                                .error(v-if="error_password !== null") {{ error_password }}

                        .field
                            .field__label
                                label.block.text-sm.font-bold.mb-2(for="password_confirmation") Password Confirmation {{ route_name === 'PageUsersCreate' ? '*' : ''}}
                            .field__form
                                input.field-style(id="password_confirmation" name="password_confirmation" type="password" v-model="password_confirmation" maxlength="255")
                                .error(v-if="error_password_confirmation !== null") {{ error_password_confirmation }}


                    .flex.items-center.justify-end.mb-8
                        button.ml-2.btn-default.btn-large(type='button' @click="reset()")
                            | Reset
                        button.ml-2.btn-primary-o.btn-large(type='submit' @click="submit($event, true)")
                            | Save &amp; Continue
                        button.ml-2.btn-primary.btn-large(type='submit' @click="submit")
                            | Save

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from '@/components/HeaderGlobal.vue';

export default {
    name: 'PageUsersForm',
    components: {
        HeaderGlobal,
    },
    data: function() {
        return {
            photo: '',
            name: '',
            email: '',
            phone: '',
            username: '',
            username_bot: '',
            status: '',
            client_id: '',
            role_id: '',
            password: '',
            password_confirmation: '',
            type_form: '',
            client_id_old: '',

            // error field
            error_photo: '',
            error_name: '',
            error_username: '',
            error_username_bot: '',
            error_phone: '',
            error_email: '',
            error_status: '',
            error_client_id: '',
            error_role_id: '',
            error_password: '',
            error_password_confirmation: '',
            // ImgAvatar: 'https://randomuser.me/api/portraits/men/9.jpg',
            ImgAvatar: this.$store.getters.getDefaultImage,

            isAstro: process.env.VUE_APP_ASTRO,
            tableTheadBotMenu:[
                {
                    name: 'Menu Bot',
                    // number: true,
                },{
                    name: 'Action',
                    action: true,
                },
            ],
            // load_data_status_bot_menu:'',
            // bot_menu_list:{
            //     'data':[
            //         {
            //             'label': 'test1',
            //             'name': 'test 1',
            //             'name': 'test 1',
            //         },
            //         {
            //             'label': 'test2',
            //             'name': 'test 2',
            //         },
            //         {
            //             'label': 'test3',
            //             'name': 'test 3',
            //         },
            //     ]
            // },
            bot_menu:[],
        };
    },
    computed: {
        ...mapState([
            'load_data_status_users_detail',
            'load_data_status_roles_list',
            'users_detail',
            'clients_list',
            'roles_list',
            'auth_data',

            'bot_menu_list',
            'load_data_status_bot_menu_list',
        ]),
        route_name() {
            return this.$route.name;
        },
        id() {
            console.log('this.$route.params.id')
            console.log(this.$route.params.id)
            return this.$route.params.id;
        },
        breadcrumb() {
            let page = {
                name: 'Edit User',
                url: '/users/'+this.id+'/edit',
            };
            if (this.route_name === 'PageUsersCreate')
                page = {
                    name: 'Add User',
                    url: '/users/create',
                };

            return [
                {
                    name: 'Users',
                    url: '/users',
                },
                page,
            ];
        },
        page_title() {
            let title = 'Edit User';
            if (this.route_name === 'PageUsersCreate')
                title = 'Add User';
            return title;
        },
    },
    watch: {
        route_name() {
            this.getData();
        },
        id() {},
        breadcrumb() {},
        page_title() {},
        // form data
        users_detail(newData) {
            this.photo = (newData.photo ? newData.photo : '');
            this.name = (newData.name ? newData.name : '');
            this.email = (newData.email ? newData.email : '');
            this.phone = (newData.phone ? newData.phone : '');
            this.username = (newData.username ? newData.username : '');
            this.username_bot = (newData.username_bot ? newData.username_bot : '');

            if (this.isAstro !== 'true' && this.auth_data && this.auth_data.role && this.auth_data.role.label === 'superadmin') {
                if (newData.client && newData.client.label&& newData.client.label.toLowerCase() === 'bot-telegram'){
                    this.type_form = 'bot';
                } else {
                    this.client_id = (newData.client && newData.client.id ? newData.client.id : '');

                }
            }

            this.role_id = (newData && newData.role && newData.role.id ? newData.role.id : '');
            console.log('this.role_id')
            console.log(this.role_id)
            this.status = (newData.status ? (newData.status.toLowerCase() === 'active' ? '1' : '0') : '');

            // this.password = (newData.password ? newData.password : '');
        },

        type_form() {
            if (this.type_form=='bot'){
                let check = this.clients_list.data.find(e => e.label.toLowerCase()==='bot-telegram')
                
                if(check){
                    this.client_id_old=this.client_id
                    this.client_id=check.id
                }
            } else {
                if (this.client_id_old)
                    this.client_id=this.client_id_old
                this.bot_menu = []
            }
        },
        bot_menu_list() {
            let self=this
            Object.values(self.bot_menu_list.data).forEach(function (item) {
                console.log({item})
                console.log(item.checked)
                if (item.checked==true || item.checked=='true')
                    self.bot_menu.push(item.index)
                });
        },
        photo() {},
        username() {},
        name() {},
        email() {},
        phone() {},
        client_id(newData) {
            console.log('watch client_id')
            console.log(newData)
            console.log(this.role_id)
            // let temp_role_id = this.role_id;
            if (this.isAstro !== 'true' && this.auth_data && this.auth_data.role && this.auth_data.role.label === 'superadmin') {
                // this.role_id = '';

                if (newData !== undefined && newData !== '' && newData !== null) {
                    this.$store.dispatch('getRolesList', [200, 1, null, null, null, null, newData]);

                    // this.$store.dispatch('getRolesList', [200, 1, null, null, null, null, this.auth_data.client.id]);

                    console.log('watch client in superadmin')
                    console.log(newData)
                } else {
                    console.log('watch client in set empty roles')
                    this.$store.commit('setRolesList', {});
                }
            }
            //  else {
            //     this.role_id = temp_role_id;
            // }

            console.log('end watch client_id')
            console.log(this.role_id)
        },
        load_data_status_roles_list(newData) {
            if (newData === 'loading') {
                this.showLoading(true);
            } else {
                this.showLoading(false);
            }
        },
        role_id() {},
        status() {},
        password() {},
    },
    methods: {
        setEmptyRoleId() {
            this.role_id = '';
        },
        getData() {
            console.log('=================== getData() route on roles form')

            this.photo = '';
            this.name = '';
            this.email = '';
            this.phone = '';
            this.username = '';
            this.username_bot = '';
            this.status = '';
            this.client_id = '';
            this.role_id = '';
            this.password = '';
            this.password_confirmation = '';
            this.client_id_old = '';
            this.type_form= '',
            this.bot_menu= [],

            this.error_username = '';
            this.error_username_bot = '';
            this.error_photo = '';
            this.error_name = '';
            this.error_email = '';
            this.error_phone = '';
            this.error_status = '';
            this.error_client_id = '';
            this.error_role_id = '';
            this.error_password = '';
            this.error_password_confirmation = '';

            // get client list
            if (this.route_name === 'PageUsersEdit' || this.route_name === 'PageUsersCreate') {
                
                this.showLoading(true);

                // temporary
                if (this.isAstro !== 'true' && this.auth_data.role && this.auth_data.role.label === 'superadmin') {
                    // console.log(this.auth_data.role.label)
                    this.$store.dispatch('getClientsList', [200, 1]);
                
                } else {
                    // after client_id is not used
                    console.log('this.auth_data.client')
                    console.log(this.auth_data.client)
                    this.$store.dispatch('getRolesList', [200, 1, null, null, null, null, this.auth_data.client.id]);
                }

                this.password = '';
                this.password_confirmation = '';
                
                this.showLoading(false);
            }

            if (this.route_name === 'PageUsersEdit') {
                // console.log(this.id);

                // for dispatch get data

                this.showLoading(true);
                console.log('this.id')
                console.log(this.id)
                this.$store.dispatch('getUsersDetail', [this.id])
                .then((resp) => {
                    if (resp === 'success') {

                this.showLoading(true);
                        this.showLoading(false);

                    } else {
                        this.error();
                    }
                });
                this.$store.dispatch('getBotMenuList', [this.id]);

            } else {
                if (this.route_name === 'PageUsersCreate'){
                    this.$store.commit('setUsersDetail', {});
                    this.$store.dispatch('getBotMenuList',[]); 
                }
            }
        },
        changeImgAvatar(e) {
            const file = e.target.files[0];
            this.ImgAvatar = URL.createObjectURL(file);
        },
        validateEmail(email) {
            /* eslint-disable no-useless-escape */
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        reset() {
            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset form?',
                // text: id,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    if (this.route_name === 'PageUsersCreate') {
                        this.photo = '';
                        this.name = '';
                        this.email = '';
                        this.phone = '';
                        this.username = '';
                        this.username_bot = '';
                        this.status = '';
                        this.client_id = '';
                        this.role_id = '';
                        this.password = '';
                        this.password_confirmation = '';
                        this.client_id_old = '';
                        this.type_form= '',
                        this.bot_menu= [],

                        this.error_photo = '';
                        this.error_name = '';
                        this.error_username = '';
                        this.error_username_bot = '';
                        this.error_email = '';
                        this.error_phone = '';
                        this.error_status = '';
                        this.error_client_id = '';
                        this.error_role_id = '';
                        this.error_password = '';
                        this.error_password_confirmation = '';
                    } else {
                        this.getData();
                    }
                }
            });
        },
        submit(e, save_continue=false){
            e.preventDefault();
            // console.log('=================== submit() route on roles form')
            // console.log(e);

            // console.log([this.name, this.email, this.role_id, this.status, this.password]);
            // this.getData();

            this.showLoading(true);

            this.error_photo = '';
            this.error_name = '';
            this.error_username = '';
            this.error_username_bot = '';
            this.error_email = '';
            this.error_phone = '';
            this.error_status = '';
            this.error_client_id = '';
            this.error_role_id = '';
            this.error_password = '';
            this.error_password_confirmation = '';

            // validation
            if (this.name.length==0 || this.email.length==0 || this.role_id.length==0 || this.status.length==0 || (this.route_name === 'PageUsersCreate' ? this.password.length==0 || this.password_confirmation.length==0 : false) || (this.isAstro !== 'true' && this.auth_data.role && this.auth_data.role.label === 'superadmin' ? this.client_id.length==0 : false) ) {

                // this.error_photo = (this.photo.length==0 ? 'Field photo is required.' : '');
                this.error_name = (this.name.length==0 ? 'Field name is required.' : '');
                this.error_email = (this.email.length==0 ? 'Field email is required.' : '');
                this.error_username = (this.username.length==0 ? 'Field username is required.' : '');
                // this.error_username_bot = (this.username_bot.length==0 ? 'Field username bot is required.' : '');
                this.error_status = (this.status.length==0 ? 'Field status is required.' : '');
                this.error_client_id = (this.client_id.length==0 ? 'Field client is required.' : '');
                this.error_role_id = (this.role_id.length==0 ? 'Field role is required.' : '');

                this.error_password = (this.password.length==0 && this.route_name === 'PageUsersCreate' ? 'Field password is required.' : '');
                this.error_password_confirmation = (this.password_confirmation.length==0 && this.route_name === 'PageUsersCreate' ? 'Field password confirmation is required.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data is required!',
                    text: 'Name, email,'+ (this.isAstro !== 'true' && this.auth_data.role && this.auth_data.role.label === 'superadmin' && this.client_id.length==0 ? ' client,' : '') +' role'+ (this.route_name === 'PageUsersCreate' ? ', status, password, & password confirmation' : ', & status' ) +' is required!',
                    // timer: 3000,
                });

                return;
            }

            if (this.name.length>255 || this.email.length>255 || this.phone.length>255 || this.password.length>255 || this.password_confirmation.length>255) {

                // this.error_photo = (this.photo.length>255 ? 'Field photo is not more than 255 characters.' : '');
                this.error_name = (this.name.length>255 ? 'Field name is not more than 255 characters.' : '');
                this.error_email = (this.email.length>255 ? 'Field email is not more than 255 characters.' : '');
                this.error_phone = (this.phone.length>255 ? 'Field phone is not more than 255 characters.' : '');
                // this.error_status = (this.status.length>255 ? 'Field status is not more than 255 characters.' : '');
                // this.error_client_id = (this.client_id.length>255 ? 'Field client is not more than 255 characters.' : '');
                // this.error_role_id = (this.role_id.length>255 ? 'Field role is not more than 255 characters.' : '');

                this.error_password = (this.password.length>255 ? 'Field password is not more than 255 characters.' : '');
                this.error_password_confirmation = (this.password_confirmation.length>255 ? 'Field password confirmation is not more than 255 characters.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data length is not more than 255 characters!',
                    text: 'Name, email, password, & password confirmation is not allowed more than 255 characters!',
                    // timer: 3000,
                });

                return;
            }

            if (!this.validateEmail(this.email)) {
                this.error_email = 'The email must be a valid email address.';

                this.$swal.fire({
                    title: 'Email must be a valid email address.',
                    icon: 'warning',
                    // timer: 3000,
                });
                return;
            }

            if (this.password.length > 0 || this.password_confirmation.length > 0) {

                if (this.password !== this.password_confirmation) {

                    this.error_password_confirmation = 'Password confirmation is not match.';

                    this.$swal.fire({
                        icon: 'warning',
                        title: 'Password confirmation is not match!',
                        text: 'Password & password confirmation  is not match!',
                        // timer: 3000,
                    });

                    return;
                }
            }

            if (this.route_name === 'PageUsersCreate') {

                // this.$store.dispatch('getUsersCreate', [this.name, this.email, this.phone, this.role_id, this.status, this.password, this.username])
                this.$store.dispatch('getUsersCreate', [this.name, this.email, this.phone, this.client_id, this.role_id, this.status, this.password, this.username, this.username_bot, this.bot_menu])
                .then((resp) => {
                    if (resp.result === 'success') {
                        // this.$router.push({ name: 'PageUsersIndex' });
                        if (save_continue === false) {
                            this.$router.push('/users');
                        } else {
                            this.$router.push('/users/'+ resp.data.data.id +'/edit');
                        }

                        this.password = '';
                        this.password_confirmation = '';

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully created!',
                            timer: 3000,
                        });
                    } else {
                        
                        if (resp.data.message && resp.data.message.errors) {
                            // this.error_photo = (resp.data.message.errors.photo ? resp.data.message.errors.photo : '');
                            this.error_name = (resp.data.message.errors.name ? resp.data.message.errors.name : '');
                            this.error_email = (resp.data.message.errors.email ? resp.data.message.errors.email : '');
                            this.error_username = (resp.data.message.errors.username ? resp.data.message.errors.username : '');
                            this.error_username_bot = (resp.data.message.errors.username_bot ? resp.data.message.errors.username_bot : '');
                            this.error_phone = (resp.data.message.errors.phone ? resp.data.message.errors.phone : '');
                            this.error_status = (resp.data.message.errors.status ? resp.data.message.errors.status : '');
                            this.error_client_id = (resp.data.message.errors.client_id ? resp.data.message.errors.client_id : '');
                            this.error_role_id = (resp.data.message.errors.role_id ? resp.data.message.errors.role_id : '');
                            this.error_password = (resp.data.message.errors.password ? resp.data.message.errors.password : '');
                            // this.error_password_confirmation = (resp.data.message.errors.password_confirmation ? resp.data.message.errors.password_confirmation : '');

                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });

            // PageUsersEdit
            } else {

                // this.$store.dispatch('getUsersUpdate', [this.id, this.name, this.email, this.role_id, this.status, (this.password.length!==0 ? this.password.length : null)])
                // this.$store.dispatch('getUsersUpdate', [this.id, this.name, this.email, this.phone, this.role_id, this.status, this.password, this.username])

                this.$store.dispatch('getUsersUpdate', [this.id, this.name, this.email, this.phone, this.client_id, this.role_id, this.status, this.password, this.username, this.username_bot, this.bot_menu])
                .then((resp) => {
                    if (resp.result === 'success') {
                        // this.$router.push({ name: 'PageUsersIndex' });
                        if (save_continue === false)
                            this.$router.push('/users');

                        this.password = '';
                        this.password_confirmation = '';

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully updated!',
                            timer: 3000,
                        });
                    } else {
                        if (resp.data.message && resp.data.message.errors) {
                            // this.error_photo = (resp.data.message.errors.photo ? resp.data.message.errors.photo : '');
                            this.error_name = (resp.data.message.errors.name ? resp.data.message.errors.name : '');
                            this.error_email = (resp.data.message.errors.email ? resp.data.message.errors.email : '');
                            this.error_phone = (resp.data.message.errors.phone ? resp.data.message.errors.phone : '');
                            this.error_username = (resp.data.message.errors.username ? resp.data.message.errors.username : '');
                            this.error_username_bot = (resp.data.message.errors.username_bot ? resp.data.message.errors.username_bot : '');
                            this.error_status = (resp.data.message.errors.status ? resp.data.message.errors.status : '');
                            this.error_client_id = (resp.data.message.errors.client_id ? resp.data.message.errors.client_id : '');
                            this.error_role_id = (resp.data.message.errors.role_id ? resp.data.message.errors.role_id : '');
                            this.error_password = (resp.data.message.errors.password ? resp.data.message.errors.password : '');
                            // this.error_password_confirmation = (resp.data.message.errors.password_confirmation ? resp.data.message.errors.password_confirmation : '');

                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    // errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: 'Something wrong.',
                html: errors,
                // timer: 3000
            });
        },
    },
    mounted() {
        // console.log('=================== mounted on users form')
        this.getData();
    },
   
}
</script>

<style lang="sass">


</style>
